import Header from '../components/Landing/Header';
import Navbar from '../components/Landing/Navbar';
import Features from '../components/Landing/Features';
import ReadyToTry from '../components/Landing/ReadyToTry';
import Footer from '../components/Landing/Footer';
export default function Landing() {
    // delete  haves "bg-gradient-to-r sm:px-4 from-brand-darkest to-brand-darkest2" classes
    
    let findDiv = document.querySelectorAll('div')[1];
    if (findDiv) {
        findDiv.classList.remove('bg-gradient-to-r', 'from-brand-darkest', 'to-brand-darkest2');
    }

    return (
        <div className='flex w-full h-full flex-col'>
            <Navbar />
            <Header />
            <Features />
            <ReadyToTry />
            <Footer />
        </div>
    );
}
